// extracted by mini-css-extract-plugin
export var cardHeader = "_h2-0";
export var reorderHandle = "_h2-3";
export var titleArea = "_h2-1";
export var titleAreaWithHandle = "_h2-2";